import styled from 'styled-components';
import { animated } from 'react-spring';
import { TextWhite } from 'styles/common/TextStyle';

export const BoxText = styled(TextWhite)`
  @media (max-width: 426px) {
    font-size: 10px;
  }

  .red-text {
    color:red;
  }
`

export const BottomSheetBox = styled(animated.div)`
  background: ${({ theme }) => theme.colors.primary.gradient};
  box-sizing: border-box;
  color: white;
  position: fixed;
  width: 100%;
  padding: 20px;
  padding-bottom: 30px;
  z-index: 2;
  bottom: ${({ theme, open }) => (open ? '60px' : '0px')};
  height: 180px;
  left: 0;
  min-width: 300px;
  transition: bottom 0.5s ease;
  min-width: 360px;
`;

export const ToggleButton = styled(animated.div)`
  position: fixed;
  left: 50%;
  right: 0;
  text-align: center;
  padding: 8px;
  padding-bottom: 10px;
  width: 110px;
  max-width: 113px;
  border-radius: 20px 20px 0px 0px;
  background: ${({ theme }) => theme.colors.primary.gradient};
  bottom: ${({ theme, open }) => (open ? '240px' : '60px')}; 
  transform: translateX(-50%);
  z-index: 2;
  transition: bottom 0.5s ease;
`;

export const ToggleArrow = styled.img`
  transition: transform 0.3s linear;
`;
